export default __webpack_public_path__ + "static/media/a008-3.ed70f709.svg";